import queryString from 'qs';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { fetchByQuery, filterPages, loadMorePages } from '../Actions/search';
import { search } from '../Reducers/search';

export default (
  WrappedComponent,
  componentName,
  endPoint = '/api/search/search',
  callbacks = {
    afterFetchByQuery: () => {},
    afterLoadMorePages: () => {},
  }
) => {
  class Container extends Component {
    query = queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
      indices: false,
    });
    key = this.query.p || 0;

    endPoint = this.props.SearchApiUrl || endPoint;

    //Set initial state
    state = search({
      isLoading: false,
      ...this.props.SearchResult,
    });

    getComponentName() {
      return componentName;
    }

    //TODO: Change to redux
    dispatch(action) {
      this.setState(search(this.getState(), action));
    }

    getState() {
      return this.state;
    }

    fetch(query) {
      fetchByQuery(`${this.endPoint}?${query}`)(
        this.dispatch.bind(this),
        this.getState.bind(this),
        callbacks.afterFetchByQuery
      );
    }

    updateSearchFromUrl(locationSearch) {
      const qs = queryString.parse(locationSearch, {
        ignoreQueryPrefix: true,
        indices: false,
      });

      qs.componentname = this.getComponentName();

      if (this.props.Theme) qs.theme = this.props.Theme;
      if (this.props.InformationType)
        qs.informationtype = this.props.InformationType;
      if (this.props.SearchOriginId) qs.so = this.props.SearchOriginId;
      if (this.state.BatchSize && !qs.batchsize)
        qs.batchsize = this.state.BatchSize;
      if (this.state.SortOrder) qs.sortorder = this.state.SortOrder;
      if (this.state.HistoryDays) qs.days = this.state.HistoryDays;
      if (this.state.RootLink) qs.rootLink = this.state.RootLink;
      if (this.state.Categories && this.state.Categories.length > 0) {
        qs.category = this.state.Categories;
      }
      if (this.state.IsArticleSearch) {
        qs.isArticleSearch = this.state.IsArticleSearch;
      }

      const query = this.props.Categories
        ? `${queryString.stringify(qs, {
            indices: false,
          })}&${queryString.stringify({
            category: this.props.Categories,
            indices: false,
          })}`
        : queryString.stringify(qs, { indices: false });

      const isExternalSearch = !!qs.site;

      const endpoint = isExternalSearch
        ? this.getExternalEndpoint({
            searchApiUrl: this.props.SearchApiUrl,
            searchApiIndex: qs.site,
            location: this.props.location,
          })
        : this.endPoint;

      if (qs.p) {
        loadMorePages(`${endpoint}?${query}`)(
          this.dispatch.bind(this),
          this.getState.bind(this),
          callbacks.afterLoadMorePages
        );
      } else {
        filterPages(`${endpoint}?${query}`)(
          this.dispatch.bind(this),
          this.getState.bind(this)
        );
      }
    }

    componentDidMount() {
      if (this.props.searchOnMount) {
        this.updateSearchFromUrl(this.props.location.search);
      }
    }

    componentDidUpdate(prevProps) {
      if (prevProps.location.search !== this.props.location.search) {
        this.updateSearchFromUrl(this.props.location.search);
      }
    }

    getExternalEndpoint({ searchApiUrl, searchApiIndex, location }) {
      const apiEndpoint = searchApiUrl?.endsWith('/')
        ? searchApiUrl
        : `${searchApiUrl || ''}/`;

      const endpointWithSiteIndex = searchApiIndex
        ? `${apiEndpoint}${searchApiIndex}/`
        : apiEndpoint;

      const pathnameSegments =
        location?.pathname?.split('/').filter(Boolean) || [];
      const regionalizedSearch =
        pathnameSegments.length > 1 ? pathnameSegments[0] : '';

      return regionalizedSearch
        ? `${endpointWithSiteIndex}${regionalizedSearch}/`
        : endpointWithSiteIndex;
    }

    parseForm(form) {
      var obj = {};
      var elements = form.querySelectorAll('input, select, textarea');
      for (var i = 0; i < elements.length; ++i) {
        var element = elements[i];
        var name = element.name;
        var value = element.value;

        if (name) {
          obj[name] = value;
        }
      }
    }

    onSubmit(e, query) {
      e.preventDefault();
      const pathname = this.props.location.pathname;
      const qs = queryString.stringify(query, { indices: false });
      location.href = `${pathname}?${qs}`;
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          SearchResult={this.state}
          Search={(query) => this.fetch(query)}
          onSubmit={(e, query) => this.onSubmit(e, query)}
        />
      );
    }
  }

  return withRouter(Container);
};
